// extracted by mini-css-extract-plugin
export default {"paymentSection":"X7-z","disabled":"Y7-z"};